<h2 mat-dialog-title>

  <span *ngIf="selectedArticle.title">{{'COMMON.EDIT' | translate}} - {{selectedArticle.title}}</span>
  <span *ngIf="!selectedArticle.title">{{'COMMON.CREATE_NEW' | translate}}</span>

</h2>
<mat-dialog-content [formGroup]="form">


  <mat-tab-group (selectedTabChange)="onSelectedTabChanged($event)">
    <mat-tab class="modal-tab" label="{{'ARTICLE.TAB.0' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'ARTICLE.TAB.1' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'ARTICLE.TAB.2' | translate}}"></mat-tab>
  </mat-tab-group>

  <form [formGroup]="form">
    <div class="tab-content-container">

      <div [hidden]="activeTabIndex !== 2" class="uploader-container">
        <img *ngIf="selectedArticle && selectedArticle.imageUrl" [src]="selectedArticle.imageUrl">
        <mat-icon class="dark" *ngIf="selectedArticle && selectedArticle.imageUrl" (click)="deleteCoverImage()">delete
        </mat-icon>

        <app-custom-drop-zone
          *ngIf="!selectedArticle || !selectedArticle.imageUrl"
          (uploadFinished)="onUploadFinished($event)"
          [uploadPath]="'article'"
          [height]="'250px'">
        </app-custom-drop-zone>

      </div>

      <div [hidden]="activeTabIndex !== 1">

        <app-html-editor-wrapper
          [value]="form.controls['body'].value"
          [editMode]="true" [showButtons]="false"
          (contentChanged)="onArticleContentChanged($event)"></app-html-editor-wrapper>

      </div>

      <div [hidden]="activeTabIndex !== 0">
        <div class="row">
          <div class="col-12">

            <mat-form-field>

              <input matInput
                     type="text"
                     placeholder="{{'ARTICLE.TITLE' | translate}}"
                     formControlName="title">

            </mat-form-field>

          </div>

          <div class="col-12">
            <mat-form-field>
              <mat-label>{{'ARTICLE.SUMMARY' | translate}}</mat-label>
              <textarea matInput formControlName="summary" matTextareaAutosize matAutosizeMinRows=2
                        matAutosizeMaxRows=5></textarea>
            </mat-form-field>
          </div>


          <div class="col-12">
            <mat-form-field>
              <input
                (click)="openCalendar()"
                readonly
                formControlName="createdAt" autocomplete="false" matInput [matDatepicker]="picker"
                placeholder="{{'REFERENCE.CREATED_AT' | translate}}">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker startView="year" [startAt]="startDate"></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-12">

            <mat-form-field>

              <input matInput
                     type="text"
                     placeholder="{{'ARTICLE.LINK' | translate}}"
                     formControlName="link">

            </mat-form-field>

          </div>

          <div class="col-12">

            <mat-checkbox formControlName="highlighted">{{'ARTICLE.HIGHLIGHTED' | translate}}</mat-checkbox>

          </div>

        </div>
      </div>

    </div>
  </form>

</mat-dialog-content>

<app-modal-footer [disabled]="!form.valid" (submit)="save()" (close)="close()"></app-modal-footer>
